import { createSlice } from '@reduxjs/toolkit'

type Props = {
  dialogRewardsQuestionnaireState: boolean
  rewardsQuestionnaireAnswerState: boolean
}

const initialState: Props = {
  dialogRewardsQuestionnaireState: false,
  rewardsQuestionnaireAnswerState: false,
}

const dialogRewardsReducer = createSlice({
  name: 'dialogRewards',
  initialState: initialState,
  reducers: {
    dialogRewardsQuestionnaireState(state, action) {
      state.dialogRewardsQuestionnaireState = action.payload
    },
    rewardsQuestionnaireAnswerState(state, action) {
      state.rewardsQuestionnaireAnswerState = action.payload
    },
  },
})

export const { dialogRewardsQuestionnaireState, rewardsQuestionnaireAnswerState } = dialogRewardsReducer.actions

export default dialogRewardsReducer.reducer
